// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.storage-display-loading {
  font-size: 12px;
  color: #666;
  text-align: center;
  padding: 10px 0;
}

.storage-display-container {
  margin: 15px 0;
  padding: 12px 0;
  border-top: 1px solid #eaeaea;
  border-bottom: 1px solid #eaeaea;
}
.storage-display-container .storage-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
  font-size: 13px;
}
.storage-display-container .storage-header .storage-label {
  font-weight: 500;
  color: #333;
  white-space: nowrap;
}
.storage-display-container .storage-header .storage-stats {
  color: #666;
  font-size: 12px;
  white-space: nowrap;
  text-align: right;
}
.storage-display-container .storage-progress-bar {
  width: 100%;
  height: 6px;
  background-color: #f0f0f0;
  border-radius: 4px;
  overflow: hidden;
}
.storage-display-container .storage-progress-bar .storage-progress-fill {
  height: 100%;
  border-radius: 4px;
  transition: width 0.4s ease-in-out, background-color 0.4s ease;
}`, "",{"version":3,"sources":["webpack://./src/components/StorageDisplay/StorageDisplay.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AACJ;;AAEA;EACI,cAAA;EACA,eAAA;EACA,6BAAA;EACA,gCAAA;AACJ;AACI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;AACR;AACQ;EACI,gBAAA;EACA,WAAA;EACA,mBAAA;AACZ;AAEQ;EACI,WAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;AAAZ;AAII;EACI,WAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAFR;AAIQ;EACI,YAAA;EACA,kBAAA;EACA,8DAAA;AAFZ","sourcesContent":[".storage-display-loading {\r\n    font-size: 12px;\r\n    color: #666;\r\n    text-align: center;\r\n    padding: 10px 0;\r\n}\r\n\r\n.storage-display-container {\r\n    margin: 15px 0;\r\n    padding: 12px 0;\r\n    border-top: 1px solid #eaeaea;\r\n    border-bottom: 1px solid #eaeaea;\r\n\r\n    .storage-header {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n        gap: 10px;\r\n        margin-bottom: 8px;\r\n        font-size: 13px;\r\n\r\n        .storage-label {\r\n            font-weight: 500;\r\n            color: #333;\r\n            white-space: nowrap;\r\n        }\r\n\r\n        .storage-stats {\r\n            color: #666;\r\n            font-size: 12px;\r\n            white-space: nowrap;\r\n            text-align: right;\r\n        }\r\n    }\r\n\r\n    .storage-progress-bar {\r\n        width: 100%;\r\n        height: 6px;\r\n        background-color: #f0f0f0;\r\n        border-radius: 4px;\r\n        overflow: hidden;\r\n\r\n        .storage-progress-fill {\r\n            height: 100%;\r\n            border-radius: 4px;\r\n            transition: width 0.4s ease-in-out, background-color 0.4s ease;\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
